import { SxProps, Theme } from '@mui/material';
import { commonStyles } from '~/theme/styles/commonStyles';

type TStyles = {
  addressInput: SxProps<Theme>;
  additinalInfoContainer: SxProps<Theme>;
  table: SxProps<Theme>;
  row: SxProps<Theme>;
  tableText: SxProps<Theme>;
};

export const styles: TStyles = {
  addressInput: () => ({
    flexGrow: 1,
    '& .MuiInputBase-input': {
      cursor: 'pointer',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  }),
  additinalInfoContainer: (theme: Theme) => ({
    ...(commonStyles.scroll(theme) as Object),
    zIndex: 2,
    width: '80%',
    overflowX: 'hidden',
  }),
  table: (theme: Theme) => ({
    width: '100%',
    background: theme.palette.common.white,
    border: `1px solid ${theme.palette.grey[100]}`,
    [theme.breakpoints.down('md')]: {
      background: 'transparent',
      border: 'none',
    },
  }),
  row: (theme: Theme) => ({
    borderBottom: `1px solid ${theme.palette.grey[100]}`,
    [theme.breakpoints.down('md')]: {
      background: theme.palette.common.white,
      border: `1px solid ${theme.palette.grey[100]}`,
      '&:last-child': {
        borderBottom: `1px solid ${theme.palette.grey[100]}`,
      },
    },
  }),
  tableText: { p: 1, textAlign: 'start', width: '100%' },
};
